import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  constructor(private http: HttpClient) {}

  fetchCountry(id: number) {
    return this.http.get<any[]>(`${environment.api}/countries/${id}`);
  }

  getAllCountries() {
    return this.http.get<any[]>(`${environment.api}/countries`);
  }
}
